var ButtonData_Type = /* @__PURE__ */ ((ButtonData_Type2) => {
  ButtonData_Type2["LINK"] = "LINK";
  ButtonData_Type2["ACTION"] = "ACTION";
  ButtonData_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return ButtonData_Type2;
})(ButtonData_Type || {});
export {
  ButtonData_Type
};
//# sourceMappingURL=plugin_button.enums.js.map
